<!-- BEGIN: Left Aside -->
<div
  class="aside aside-left d-flex flex-column flex-row-auto"
  [ngClass]="asideClasses"
>
  <!-- begin:: Brand -->
  <school-logo-ui [brandpath]='logovalue'></school-logo-ui>
  <!-- end:: Brand -->
   <!-- BEGIN: Aside Menu -->

  <ng-container>
    <!-- begin::Offcanvas Toolbar Quick Actions -->
    <div id="kt_quick_user" class="p-5" [ngStyle]="{ overflow: 'hidden' }">
      <div [ngStyle]="{ position: 'relative' }" class="scroll">
        
        <school-menuinfo-ui
          [username]="fullName"
          [designation]="designation"
          [userimg]="userimg"
          [signoutlink]="signoutlink"
        ></school-menuinfo-ui>

        <div class="navi navi-spacer-x-0 p-0">
          <a
            href="javascript:void(0)"
            [routerLink]="item.urlLink"
            routerLinkActive="nav-item-active"
            class="navi-item"
            (click)="Menuclick(item.title)"
            *ngFor="let item of Menulists; let i = index; trackBy: identify"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-xl">
                    <span [inlineSVG]="item.icon"></span>
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">{{ item.title }} &nbsp;
                  <span
                    *ngIf="item.status != ''"
                    class="label label-light-danger label-inline font-weight-bold"
                  >
                    {{ item.status }}
                  </span></div>
                <div class="text-muted">
                  {{ item.subtitle }}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- end::Offcanvas Toolbar Quick User Actions -->
  </ng-container>

  <!-- END: Aside Menu -->
</div>
<!-- END: Left Aside -->
